import { render } from "./AddressLookup.vue?vue&type=template&id=8c36d5b6&lang=pug"
import script from "./AddressLookup.vue?vue&type=script&lang=js"
export * from "./AddressLookup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__